(function() {
    'use strict';
  
    angular
      .module('iqxCore')
      .directive('iqxSparkline',iqxSparkline)

    function iqxSparkline() {
        return {
            restrict: 'E',
            scope: {sparkline: '='},
            template: `<svg id="{{sparkline.id}}" class="sparkline" style="height: 100%; width: 100%; font-size: 14px; " ng-show="!noData"></svg>
                <div ng-show="noData" style="padding:30px; opacity:0.3" class="text-center"><i class="fas fa-chart-line fa-4x"></i><h5>There is no matching data.</h5></div>`,
            controller: function($scope, nvd3Svc) {
                nvd3Svc.sparkLine($scope,$scope.sparkline.id,$scope.sparkline.spec)
            },
        }
    }
})()